// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-card[data-v-09b5c264]{position:relative;display:flex;flex-direction:column;flex-shrink:0;align-items:center;width:322px;height:100%;overflow:hidden;background:var(--general-bg-card);border-radius:var(--radius-xl)}.feature-card__gradient[data-v-09b5c264]{position:absolute;top:0;right:0;width:120px;height:120px;background:rgba(51,57,74,.8);filter:blur(60px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
